// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3q9o8","list":"BalanceDue_list__1MLQC","listRow":"BalanceDue_listRow__1MQP8","total":"BalanceDue_total__1Cert"};